import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || '';
        const match = hash.match(/session_id=([^&]+)/);
        const session_id = match ? match[1] : null;

        if (!session_id) {
            navigate('/login', { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post('/auth/session', { session_id });
                const currentPath = window.location.pathname;
                const query = new URLSearchParams(window.location.search);
                // Clear hash so we don't reprocess on any future re-mount
                window.history.replaceState(null, '', currentPath + window.location.search);
                await refresh();
                // If OAuth was triggered from the Match assessment gate, return there.
                if (currentPath === '/match/unlock' && query.get('sid')) {
                    navigate(`/match?unlock_sid=${encodeURIComponent(query.get('sid'))}`, { replace: true });
                    return;
                }
                navigate('/dashboard', { replace: true, state: { user: data.user } });
            } catch (e) {
                navigate('/login', { replace: true });
            }
        })();
    }, [navigate, refresh, location]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center text-neutral-500 text-[14px]">
            Signing you in…
        </div>
    );
}
